import styled from 'styled-components';

export const StyledHandlerList = styled.div`
    padding: 2rem;
`;
